import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const ArrowblockSENW = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path d="M11 19l3-3-6-6-3 3V6h7L9 9l6 6 3-3v7h-7z" />
  </SvgIcon>
);

export default ArrowblockSENW;
